export default __webpack_public_path__ + "static/media/MaduroNub.7d782366.png";